module.exports = {"451321100":"城关镇","451321101":"大塘镇","451321102":"思练镇","451321103":"红渡镇","451321104":"古蓬镇","451321105":"果遂镇","451321201":"马泗乡","451321202":"欧洞乡","451321203":"安东乡","451321205":"新圩乡","451321206":"遂意乡","451321207":"北更乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451321.json
// module id = 1995
// module chunks = 0